import React from "react";
import Header from "../../../Home/Header";
import Footer from "../../../Home/Footer";
import BSCHero from "./BSCHero";
import BinanceSmartChain from "./BinanceSmartChain";
import XeerBSC from "./XeerBSC";
import BenefitsBSC from "./BenefitsBSC";

function BSC() {
  return (
    <div>
      <Header />
      <BSCHero />
      <BinanceSmartChain />
      <XeerBSC />
      <BenefitsBSC />
      <Footer />
    </div>
  );
}

export default BSC;
